// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","headerWrapperImage":"Header_headerWrapperImage__9wV7G","headerImage":"Header_headerImage__98I0z"};